import ObjectUtil from "../../../../../react/core/utils/ObjectUtil";
import * as _ from "lodash";

var HeaderPlanMessagingDelegate = function ($q, $window, MessagingFactory) {
    var throttledMessagesListQuery = _.throttle(MessagingFactory.messagesList.query, 1000, {
        trailing: true
    });

    var getMessagesListSuccess = function (res) {
        var list = res.data;

        if (ObjectUtil.isUndefinedOrNull(list)) {
            return [];
        }

        if (list.hasOwnProperty("slides")) {
            list = res.data.slides;
        }

        var slides = _._(list)
            .sortBy((message) => {
                let subjectTypeSortOrder = ["PA", "GA", "ACC", "GEN"];
                return _.indexOf(subjectTypeSortOrder, message.subjectType);
            })
            .filter((message) => {
                return message;
            })
            .map((m, index) => {
                let navigable = _.includes(_.get(m, "information"), "apple-k");

                return _.extend(m, {
                    expand: false,
                    appleHtml: _.includes(_.get(m, "planName"), "Apple"),
                    active: index === 0,
                    navigable: navigable,
                    onClick: navigable
                        ? function () {
                              let account = accountService.getActiveGroupAccount();
                              window.location.href = [
                                  LegacyService.getCurrentDomain(),
                                  "participant/accounts/",
                                  "#/account/",
                                  account.individualId,
                                  "/",
                                  account.groupId,
                                  "/contribution"
                              ].join("");
                          }
                        : _.noop
                });
            })
            .value();

        return slides;
    };

    var getMessagesListFault = function (err) {
        return $q.reject(err);
    };

    var getMessagesList = function () {
        return throttledMessagesListQuery({}, getMessagesListSuccess, getMessagesListFault)
            .$promise;
    };

    return {
        getMessagesList: getMessagesList
    };
};

HeaderPlanMessagingDelegate.$inject = ["$q", "$window", "MessagingFactory"];
export default HeaderPlanMessagingDelegate;
